import React, { useState, useEffect, useRef } from 'react';
import Toggle from '~/components/Toggle';

const AddNoteModal: React.FC = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [isVisible, setIsVisible] = useState(false);

    const trigger = useRef<any>(null);
    const modal = useRef<any>(null);

    // close on click outside
    useEffect(() => {
        const clickHandler = ({ target }: MouseEvent) => {
            if (!modal.current) return;
            if (
                !modalOpen ||
                modal.current.contains(target) ||
                trigger.current.contains(target)
            )
                return;
            setModalOpen(false);
        };
        document.addEventListener('click', clickHandler);
        return () => document.removeEventListener('click', clickHandler);
    });

    // close if the esc key is pressed
    useEffect(() => {
        const keyHandler = ({ keyCode }: KeyboardEvent) => {
            if (!modalOpen || keyCode !== 27) return;
            setModalOpen(false);
        };
        document.addEventListener('keydown', keyHandler);
        return () => document.removeEventListener('keydown', keyHandler);
    });

    return (
        <>
            <button
                ref={trigger}
                onClick={() => setModalOpen(!modalOpen)}
                className='rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-black hover:bg-black hover:text-white'
            >
                Add Note
            </button>
            <div
                className={`fixed left-0 top-0 z-999999 flex h-full min-h-screen w-full items-center justify-center bg-black/90 px-4 py-5 ${
                    modalOpen ? 'block' : 'hidden'
                }`}
            >
                <div
                    ref={modal}
                    onFocus={() => setModalOpen(true)}
                    onBlur={() => setModalOpen(false)}
                    className='w-full max-w-142.5 rounded-lg bg-white p-6'
                >
                    <div className='flex justify-between'>
                        <h3 className='pb-2 text-xl font-bold sm:text-2xl'>
                            Add Note
                        </h3>
                        <div className='flex items-center gap-3'>
                            <Toggle isOn={isVisible} setIsOn={setIsVisible} />
                            Pinned
                        </div>
                    </div>

                    <label
                        htmlFor='note'
                        className='mt-[16px] block w-full text-[12px]/[14px] font-extrabold'
                    >
                        Note
                    </label>
                    <textarea
                        rows={8}
                        id='note'
                        className='w-full rounded-[4px] border-[2px] p-[10px] text-[16px]/[20px]'
                    />

                    {/* <label
            htmlFor='tags'
            className='mt-[16px] block w-full text-[12px]/[14px] font-extrabold'
          >
            Tags
          </label>
          <input
            id='tags'
            className='w-full rounded-[4px] border-[2px] p-[10px] text-[16px]/[20px]'
          /> */}

                    <div className='mt-6 flex gap-[16px]'>
                        <button
                            onClick={() => setModalOpen(false)}
                            className='rounded-full border-[2px] px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase transition-colors duration-500 hover:border-black hover:bg-black hover:text-white'
                        >
                            Cancel
                        </button>
                        <button className='rounded-full border-[2px] border-warning bg-warning px-[24px] py-[7px] text-[14px]/[18px] font-bold uppercase text-black transition-colors duration-500 hover:border-[#e6f7f8] hover:bg-[#e6f7f8]'>
                            Post
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default AddNoteModal;
